import { Clickable, Col, H2, H3, H4, List, P, Row, Section, Strong, Wrapper } from '@ahmdigital/ui';

import Banner from '../../elements/banner';
import constants from '../../ahm-constants';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import textStyles from '../../application/common/text.module.sass';

const MessagingPrivacyPolicyPage = () => (
  <LegacyBorderedWrapper>
    <Head>
      <title>Messaging Privacy Policy</title>
      <meta
        name="description"
        content="Your privacy is our biggest priority. Read about how we keep you and your information safe."
      />
    </Head>
    <Banner title="Messaging Privacy Policy" />
    <Section className={textStyles.text}>
      <Wrapper>
        <Row variant={['marginTopSpacer10', 'marginBottomSpacer9']}>
          <Col md={12} df={8}>
            <H2 variant="paddingBottomSpacer10" looksLike="h3">
              Our Messaging and Call Privacy Notice
            </H2>
            <P>
              ahm values your privacy. We will collect, use, share and process the personal information you provide
              during this conversation to address your queries and help improve our products, services and offers in
              accordance with <Clickable to={constants.URLS.SALES.PRIVACY}>ahm’s privacy policy</Clickable> (which
              contains more information about how we handle your personal information).
            </P>
            <List isOrdered>
              <li>
                <H3 looksLike="h5">Use of AI</H3>
                <P>
                  We may use artificial intelligence (<Strong>AI</Strong>) in some of our interactions and operations.
                  This page outlines how we use AI and how this may involve the handling of personal information.
                </P>
                <H4 looksLike="h6">When You Call Us</H4>
                <P>
                  When you contact us by phone, we may use AI-enabled tools to support the management and improvement of
                  customer interactions, including to:
                </P>
                <List>
                  <li>transcribe your interactions with us; and</li>
                  <li>
                    undertake high-level analytics to identify general trends and volumes across different types of
                    interactions.
                  </li>
                  <li>
                    undertake service improvement activities, including enhancing the accuracy and effectiveness of our
                    customer service technologies.
                  </li>
                </List>
                <H4 looksLike="h6">When You Chat With Us</H4>
                <P>
                  When you contact us via online chat or messaging channels, we use AI-enabled tools to help us respond
                  to your query and improve our services, including to:
                </P>
                <List>
                  <li>triage your request before we connect you with an agent;</li>
                  <li>
                    help our agents by suggesting recommended responses and to identify products that may suitable for
                    you; and
                  </li>
                  <li>generate conversation summaries and categorise the conversation intent.</li>
                </List>
              </li>
              <li>
                <H3 looksLike="h5">Surveys</H3>
                <P>
                  At the end of the online chat, we may ask for your feedback about your experience with us.
                  Participation is voluntary and your responses will remain confidential. Your feedback helps us monitor
                  our service performance, identify improvement opportunities, and better understand customer
                  experience. To do this, we may share survey responses with our service providers.
                </P>
              </li>
            </List>
            <P>
              If you have any questions about how we handle your personal information, please contact us or refer to{' '}
              <Clickable to={constants.URLS.SALES.PRIVACY}>ahm’s privacy policy</Clickable>.
            </P>
          </Col>
        </Row>
      </Wrapper>
    </Section>
  </LegacyBorderedWrapper>
);
export default MessagingPrivacyPolicyPage;
